module.exports = __webpack_public_path__ + "img/img-9.c60b0ae6.png";